function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 5H4.5A1.5 1.5 0 003 6.5v11A1.5 1.5 0 004.5 19h15a1.5 1.5 0 001.5-1.5v-8A1.5 1.5 0 0019.5 8h-13",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 5h5.5A1.5 1.5 0 0119 6.5v1M21 11h-5a2 2 0 00-2 2v0a2 2 0 002 2h5",
  stroke: "#4D4D4D",
  strokeWidth: 2
});

function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/wallet.svg";
export { SvgWallet as ReactComponent };